const Flower = ({ className }) => (
  <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1" className={className} aria-hidden="true">
    {[0, 60, 120, 180, 240, 300].map((r) => (
      <ellipse key={r} cx="20" cy="11" rx="4.5" ry="9" transform={`rotate(${r} 20 20)`} />
    ))}
    <circle cx="20" cy="20" r="2.5" />
  </svg>
);

const Petal = ({ className }) => (
  <img src="/assets/petal.png" alt="" className={className} aria-hidden="true" />
);

const spots = [
  { C: Flower, cls: "left-[3%] top-[6%] h-7 w-7 rotate-12" },
  { C: Petal, cls: "left-[12%] top-[22%] h-4 w-4 -rotate-45" },
  { C: Flower, cls: "right-[4%] top-[14%] h-5 w-5 -rotate-12" },
  { C: Petal, cls: "right-[10%] top-[32%] h-5 w-5 rotate-[30deg]" },
  { C: Flower, cls: "left-[6%] top-[44%] h-5 w-5 rotate-45" },
  { C: Petal, cls: "left-[45%] top-[12%] h-3.5 w-3.5 rotate-12" },
  { C: Flower, cls: "right-[6%] top-[56%] h-7 w-7 rotate-[20deg]" },
  { C: Petal, cls: "left-[3%] top-[66%] h-4 w-4 -rotate-[20deg]" },
  { C: Flower, cls: "left-[38%] top-[74%] h-4 w-4 rotate-[70deg]" },
  { C: Petal, cls: "right-[14%] top-[80%] h-4 w-4 rotate-[60deg]" },
  { C: Flower, cls: "left-[8%] top-[88%] h-6 w-6 -rotate-[30deg]" },
  { C: Petal, cls: "right-[4%] top-[93%] h-5 w-5 rotate-[15deg]" },
  { C: Petal, cls: "left-[55%] top-[52%] h-3.5 w-3.5 -rotate-[60deg]" },
  { C: Flower, cls: "left-[62%] top-[36%] h-5 w-5 rotate-[40deg]" },
];

export const FloralBackdrop = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden text-brand-ink" aria-hidden="true" data-testid="floral-backdrop">
    {spots.map(({ C, cls }, i) => (
      <C key={i} className={`absolute ${C === Flower ? "opacity-[0.08]" : "opacity-70"} ${cls}`} />
    ))}
  </div>
);
